// FILE: src/hooks/useSupportChannels.js
// Support contact details from GET /api/public/support-channels (MTO 1.3.4,
// 10.1). Returns null while loading, [] when nothing is configured.
import { useEffect, useState } from "react";
import { apiFetch } from "../services/api";

// Account problems are a service matter; technical support is the fallback.
const PREFERRED = ["SERVICE", "TECHNICAL"];

export function pickChannels(channels = []) {
  const reachable = channels.filter((c) => c.phone || c.email);
  const preferred = PREFERRED.map((t) => reachable.find((c) => c.type === t)).filter(Boolean);
  // Several types often share one contact; show each contact once.
  const seen = new Set();
  return preferred.filter((c) => {
    const key = `${c.phone}|${c.email}|${c.hours}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

export default function useSupportChannels(enabled = true) {
  const [channels, setChannels] = useState(null);
  useEffect(() => {
    if (!enabled || channels) return;
    let cancelled = false;
    apiFetch("/api/public/support-channels")
      .then((res) => (res.ok ? res.json() : { channels: [] }))
      .then((data) => !cancelled && setChannels(pickChannels(data.channels)))
      .catch(() => !cancelled && setChannels([]));
    return () => {
      cancelled = true;
    };
  }, [enabled, channels]);
  return channels;
}
